<template>
  <div :class="['by-form-item', { is_error: validate === 'error' }]">
    <slot ref="slot"></slot>
    <!-- <div class="error-box" v-if="validate==='error'" >
          required
      </div> -->
  </div>
</template>

<script>
export default {
  name: "ByFormItem",
  componentName: "ByFormItem",
  props: {
    required: {
      type: Boolean,
      default: false
    },
    prop: {
      type: String,
      default: ""
    }
  },
  inject: ["byForm"],
  data() {
    return {
      validate: ""
    };
  },
  mounted() {
    this.$on("by.form.blur", this.onFieldBlur);
    this.$on("by.form.submit", this.onFieldSubmit);
  },
  methods: {
    onFieldBlur(val) {
      if (this.validate === "error") {
        if (!val && this.byForm.ruleKeys.includes(this.prop)) {
          this.validate = "error";
          // this.$children[0].focus()
          // this.$refs['slot'].focus()
        } else {
          this.validate = "success";
        }
      }
      
    },
    onFieldSubmit(key) {
      // debugger
      if (this.prop === key) {
        this.validate = "error";
      }
    }
  }
};
</script>
<style scoped>
/* .by-form-item{
        position: relative;
    }
.error-box{
    position:absolute;
} */
</style>



// WEBPACK FOOTER //
// src/components/reception/checkPrice/components/ByFormItem.vue